import {
  Component,
  OnInit,
} from '@angular/core';
import {
  Location
} from '@angular/common';
import {
  AccountService,
} from '../../../_services';
import {
  Router,
  ActivatedRoute
} from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import {
  WebServiceRequestParam
} from '../../../_models/web-service-request-param';
@Component({
  templateUrl: 'dgx-xml-request-validate.component.html',
  styleUrls: ['../../../../assets/css/common.css'],
})
export class DGXXMLRequestValidateComponent implements OnInit {
  webServiceRequestParam: WebServiceRequestParam[] = [];
  returnUrl: string;
  routeXmlResponse: any;
  form: UntypedFormGroup;
  title: string;
  ErrorResponse: boolean = false;
  code: string;
  msg: string;
  line: number;
  isLoading: boolean = true;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private formBuilder: UntypedFormBuilder,
    private _location: Location,
  ) {}
  ngOnInit() {
    this.form = this.formBuilder.group({
      routeXmlContent: ['']
    });
    this.webServiceRequestParam = this.accountService.webServiceRequestParam;
    if (this.webServiceRequestParam) {
      this.isLoading = false;
      this.ErrorResponse = true;
      var obj = this.webServiceRequestParam[0]['validatedRequestResult'].err;
      this.code = obj.code;
      this.msg = obj.msg;
      this.line = obj.line;
      this.form.patchValue({
        routeXmlContent: this.webServiceRequestParam[0]['formattedRequestXmlContent']
      });
      this.routeXmlResponse = this.webServiceRequestParam[0]['formattedRequestXmlContent'];
      this.title = this.webServiceRequestParam[0]['serviceTitleXmlContent'];
    }
  }
  backClicked() {
    this._location.back();
  }
}